import Vue from 'vue'

import Qs from 'qs'

class Options {
  async indexOptionGroup({optionGroupId, params}) {
    return await Vue.axios
      .get('app/options-by-option-group/' + optionGroupId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/options', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/options/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/options/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/options/' + id)
  }
}

const options = new Options()

export default options
